/* eslint-disable @typescript-eslint/naming-convention */
export enum ContentType {
  Accordion = 'accordion',
  ActionBanner = 'action_banner',
  AppFooterContent = 'app_footer_content',
  BonusGrid = 'bonus_grid',
  Box = 'box',
  BrandLogo = 'brand_logo',
  CTAGrid = 'cta_grid',
  Carousel = 'carousel',
  CasinoCompletedRaces = 'casino_completed_races',
  CasinoGameDeck = 'casino_game_deck',
  CasinoGameGrid = 'casino_game_grid',
  CasinoGameInfo = 'casino_game_info',
  CasinoGameSlider = 'casino_game_slider',
  CasinoGameTrailer = 'casino_game_trailer',
  CasinoMosaic = 'casino_mosaic',
  CasinoMyGames = 'casino_my_games',
  CasinoMyRewards = 'casino_my_rewards',
  CasinoNewGames = 'casino_new_games',
  CasinoPlayerGames = 'casino_player_games',
  CasinoRaces = 'casino_races',
  CasinoSecondaryNavigation = 'casino_secondary_navigation',
  CasinoTopGames = 'casino_top_games',
  CategoryHighlight = 'category_highlight',
  ContentArea = 'content_area',
  ContentCard = 'content_card',
  Crm = 'crm',
  DetailsGrid = 'details_grid',
  Email = 'email',
  EntrySearchReference = 'entry_search_reference',
  EventSchedule = 'event_schedule',
  EventTournament = 'event_tournament',
  FAQ = 'faq',
  FirstWallet = 'first_wallet',
  Form = 'form',
  GeoRedirect = 'geo_redirect',
  Glossary = 'glossary',
  Grid = 'grid',
  HeaderLink = 'header_link',
  HelpBot = 'help_bot',
  HelpCenterArticle = 'help_center_article',
  HelpCenterCategory = 'help_center_category',
  HelpCenterHome = 'help_center_home',
  HelpCenterSearch = 'help_center_search',
  Highlight = 'highlight',
  IspConfig = 'isp_config',
  IconsGrid = 'icons_grid',
  LanguageBanner = 'language_banner',
  LeaderBoard = 'leader_board',
  LegacySports = 'legacy_sports',
  LinkedImageList = 'linked_image_list',
  Language = 'language',
  Main = 'main',
  MatchInfo = 'match_info',
  MediaGrid = 'media_grid',
  Menu = 'menu',
  Meta = 'meta',
  Page = 'page',
  Panel = 'panel',
  PaymentVendors = 'payment_vendors',
  Podcast = 'podcast',
  PokerHomeGames = 'poker_home_games',
  PokerMultiTableTournaments = 'poker_multi_table_tournaments',
  PokerPowerPath = 'poker_power_path',
  PokerSpinAndGo = 'poker_spin_and_go',
  PokerStarsExchange = 'poker_stars_exchange',
  PokerStarsExchangeToggle = 'poker_stars_exchange_toggle',
  PromotionBanner = 'promotion_banner',
  ProspectGrid = 'prospect_grid',
  ProspectHomepageSlide = 'prospect_homepage_slide',
  Redirect = 'redirect',
  ReferAFriend = 'refer_a_friend',
  RegulatoryHeader = 'regulatory_header',
  SEO = 'seo',
  SEOFooter = 'seo_footer',
  Side = 'side',
  SideCTA = 'side_cta',
  SideRelatedContent = 'side_related_content',
  SideTwitter = 'side_twitter',
  SiteFooter = 'site_footer',
  SiteHeader = 'site_header',
  SportsAnimalRacingMeetings = 'sports_animal_racing_meetings',
  SportsAntePostEvents = 'sports_ante_post_events',
  SportsAntePostMarket = 'sports_ante_post_market',
  SportsBetSlip = 'sports_bet_slip',
  SportsBreadcrumbs = 'sports_breadcrumbs',
  SportsCmsBanner = 'sports_cms_banner',
  SportsCompetitionEvents = 'sports_competition_events',
  SportsCompetitionOutrights = 'sports_competition_outrights',
  SportsCompetitions = 'sports_competitions',
  SportsEventInfo = 'sports_event_info',
  SportsEventTypeInfo = 'sports_event_type_info',
  SportsEventTypeSpecials = 'sports_event_type_specials',
  SportsFeatured = 'sports_featured',
  SportsFeaturedFilters = 'sports_featured_filters',
  SportsGolfMatches = 'sports_golf_matches',
  SportsHistoricalBets = 'sports_historical_bets',
  SportsHomeInPlay = 'sports_home_in_play',
  SportsHorseRacingMeetings = 'sports_horse_racing_meetings',
  SportsInPlayEvents = 'sports_in_play_events',
  SportsMarkets = 'sports_markets',
  SportsMatchFiltering = 'sports_match_filtering',
  SportsMenu = 'sports_menu',
  SportsMyBets = 'sports_my_bets',
  SportsNextRaces = 'sports_next_races',
  SportsOddsBoost = 'sports_odds_boost',
  SportsPageNotFound = 'sports_page_not_found',
  SportsPromotion = 'sports_promotion',
  SportsPromotionDetails = 'sports_promotion_details',
  SportsPromotionGrid = 'sports_promotion_grid',
  SportsQuickLinks = 'sports_quick_links',
  SportsRaceCard = 'sports_race_card',
  SportsRaceInfo = 'sports_race_info',
  SportsRacePage = 'sports_race_page',
  SportsSelfExcludedInfo = 'sports_self_excluded_info',
  SportsSEO = 'sports_seo',
  SportsSettings = 'sports_settings',
  SportsSportInPlayEvents = 'sports_sport_in_play_events',
  SportsUpcomingEvents = 'sports_upcoming_events',
  StickyFooter = 'sticky_footer',
  Tabs = 'tabs',
  Terms = 'terms',
  TilesGrid = 'tiles_grid',
  Top = 'top',
  VideoPanel = 'video_panel',
  Website = 'website',
  WebsiteConfig = 'website_config',
  WebsiteLanguages = 'website_languages'
}

export interface BasicReference {
  uid: string;
  _content_type_uid: string;
}

export interface Reference extends BasicReference {
  _content_type_uid: ContentType;
}
